import { ArticleHeading4 } from '@cian/ui-kit';

import { FC } from 'react';

import { IconNoImage } from 'shared/components/UI/Icons/IconNoImage';

import { INoImageProps } from './types';

import * as styles from './NoImage.css';

export const NoImage: FC<INoImageProps> = props => {
  const { text = 'Нет фото' } = props;

  return (
    <div className={styles['no-image']}>
      <div className={styles['no-image-icon']}>
        <IconNoImage />
      </div>
      <ArticleHeading4>{text}</ArticleHeading4>
    </div>
  );
};
